{
  "familyId": "GET-BREUK-ONG-PLUS",
  "questions": [
    {
      "id": "GET-BREUK-ONG-PLUS-001",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{3}$ + $\\frac{1}{6}$ =",
      "context": null,
      "options": ["$\\frac{3}{6}$", "$\\frac{2}{9}$", "$\\frac{1}{9}$", "$\\frac{2}{6}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_unlike_denominators",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Tellers én noemers opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-vereenvoudig-fout", "label": "Tellers en noemers vermenigvuldigd", "optionIndex": 2 },
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Eerste breuk omgezet maar tweede vergeten", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 3,
            "fractions": [
              {"numerator": 1, "denominator": 3, "label": "1/3"},
              {"numerator": 1, "denominator": 6, "label": "1/6"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 6,
            "label": "1/3 = 2/6, dan 2/6 + 1/6 = 3/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (3 en 6), dus maak ze eerst gelijk. $\\frac{1}{3}$ = $\\frac{2}{6}$ (teller en noemer × 2). Nu kun je optellen: $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$ (= $\\frac{1}{2}$). Onthoud: bij ongelijknamige breuken moet je eerst de noemers gelijk maken.",
        "solutionSteps": [
          "Herken: de noemers zijn ongelijk (3 en 6)",
          "Maak gelijknamig: $\\frac{1}{3}$ = $\\frac{2}{6}$ (× 2)",
          "Tel de tellers op: 2 + 1 = 3",
          "Antwoord: $\\frac{3}{6}$ (= $\\frac{1}{2}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{3}$ = $\\frac{2}{6}$, dan $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "1": "Je dacht waarschijnlijk dat je de tellers optelt (1+1=2) én de noemers optelt (3+6=9). Maar de noemers mag je niet optellen. Maak ze gelijk: $\\frac{1}{3}$ = $\\frac{2}{6}$, dan $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "2": "Je dacht waarschijnlijk dat je tellers en noemers apart vermenigvuldigt. Maar bij optellen maak je de noemers gelijk: $\\frac{1}{3}$ = $\\frac{2}{6}$, dan $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "3": "Je hebt $\\frac{1}{3}$ correct omgezet naar $\\frac{2}{6}$, maar vergeten de tweede breuk erbij op te tellen. $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$, niet $\\frac{2}{6}$."
        }
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-002",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{2}$ + $\\frac{1}{4}$ =",
      "context": null,
      "options": ["$\\frac{3}{4}$", "$\\frac{2}{6}$", "$\\frac{1}{4}$", "$\\frac{2}{8}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_half_quarter",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Tellers én noemers opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Eerste breuk vergeten op te tellen", "optionIndex": 2 },
          { "id": "get.breuk-vereenvoudig-fout", "label": "Tellers en noemers vermenigvuldigd", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "fractions": [
              {"numerator": 1, "denominator": 2, "label": "1/2"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "1/2 = 2/4, dan 2/4 + 1/4 = 3/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (2 en 4). Maak ze gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$ (teller en noemer × 2). Nu optellen: $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$. Onthoud: zoek een noemer waar beide breuken in passen.",
        "solutionSteps": [
          "Herken: de noemers zijn ongelijk (2 en 4)",
          "Maak gelijknamig: $\\frac{1}{2}$ = $\\frac{2}{4}$ (× 2)",
          "Tel de tellers op: 2 + 1 = 3",
          "Antwoord: $\\frac{3}{4}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$.",
          "1": "Je dacht waarschijnlijk dat je de tellers optelt (1+1=2) én de noemers optelt (2+4=6). Maar de noemers mag je niet optellen. Maak ze gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$.",
          "2": "Je hebt alleen de tweede breuk genomen en de eerste vergeten. Maak de noemers gelijk en tel op: $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$.",
          "3": "Je hebt misschien de tellers vermenigvuldigd (1×2=2) en de noemers vermenigvuldigd (2×4=8). Maar bij optellen vermenigvuldig je niet — je maakt de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$."
        }
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-003",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{4}$ + $\\frac{1}{3}$ =",
      "context": null,
      "options": ["$\\frac{7}{12}$", "$\\frac{2}{7}$", "$\\frac{2}{12}$", "$\\frac{1}{12}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_quarters_thirds",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Tellers én noemers opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Noemer gelijk gemaakt maar tellers niet omgezet", "optionIndex": 2 },
          { "id": "get.breuk-vereenvoudig-fout", "label": "Tellers en noemers vermenigvuldigd", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "fractions": [
              {"numerator": 1, "denominator": 4, "label": "1/4"},
              {"numerator": 1, "denominator": 3, "label": "1/3"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 7,
            "denominator": 12,
            "label": "1/4 = 3/12, 1/3 = 4/12, dan 3/12 + 4/12 = 7/12",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (4 en 3). Het KGV van 4 en 3 is 12. Maak gelijknamig: $\\frac{1}{4}$ = $\\frac{3}{12}$ en $\\frac{1}{3}$ = $\\frac{4}{12}$. Nu optellen: $\\frac{3}{12}$ + $\\frac{4}{12}$ = $\\frac{7}{12}$. Controleer: $\\frac{7}{12}$ is iets meer dan de helft ✓.",
        "solutionSteps": [
          "Herken: de noemers zijn ongelijk (4 en 3)",
          "Zoek het KGV van 4 en 3: dat is 12",
          "Maak gelijknamig: $\\frac{1}{4}$ = $\\frac{3}{12}$ en $\\frac{1}{3}$ = $\\frac{4}{12}$",
          "Tel de tellers op: 3 + 4 = 7",
          "Antwoord: $\\frac{7}{12}$"
        ],
        "distractorExplanations": {
          "0": "Goed! KGV van 4 en 3 is 12. $\\frac{1}{4}$ = $\\frac{3}{12}$, $\\frac{1}{3}$ = $\\frac{4}{12}$. Samen: $\\frac{7}{12}$.",
          "1": "Je dacht waarschijnlijk dat je de tellers optelt (1+1=2) én de noemers optelt (4+3=7). Maar de noemers mag je niet optellen. Zoek het KGV: 12. Dan $\\frac{3}{12}$ + $\\frac{4}{12}$ = $\\frac{7}{12}$.",
          "2": "Je hebt de tellers opgeteld (1+1=2) maar de noemer correct als 12 genomen. Vergeet niet de tellers ook om te zetten: $\\frac{1}{4}$ = $\\frac{3}{12}$ (niet $\\frac{1}{12}$) en $\\frac{1}{3}$ = $\\frac{4}{12}$ (niet $\\frac{1}{12}$).",
          "3": "Je hebt misschien de tellers vermenigvuldigd (1×1=1) en de noemers vermenigvuldigd (4×3=12). Dat is de regel voor vermenigvuldigen, niet voor optellen. Bij optellen maak je de noemers gelijk via het KGV."
        }
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-004",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Jan drinkt $\\frac{1}{3}$ liter water. Later drinkt hij nog $\\frac{1}{2}$ liter. Hoeveel heeft hij in totaal gedronken?",
      "context": null,
      "options": ["$\\frac{5}{6}$", "$\\frac{2}{5}$", "$\\frac{1}{6}$", "$\\frac{2}{6}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_context_water",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Tellers én noemers opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-vereenvoudig-fout", "label": "Tellers en noemers vermenigvuldigd", "optionIndex": 2 },
          { "id": "get.breuk-gelijkwaardig-fout", "label": "Eerste breuk omgezet maar tweede vergeten", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 3,
            "fractions": [
              {"numerator": 1, "denominator": 3, "label": "1/3 liter"},
              {"numerator": 1, "denominator": 2, "label": "1/2 liter"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "label": "1/3 = 2/6, 1/2 = 3/6, dan 2/6 + 3/6 = 5/6 liter",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (3 en 2). Het KGV van 3 en 2 is 6. Maak gelijknamig: $\\frac{1}{3}$ = $\\frac{2}{6}$ en $\\frac{1}{2}$ = $\\frac{3}{6}$. Nu optellen: $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$ liter. Jan heeft bijna een hele liter gedronken.",
        "solutionSteps": [
          "Herken: de noemers zijn ongelijk (3 en 2)",
          "Zoek het KGV van 3 en 2: dat is 6",
          "Maak gelijknamig: $\\frac{1}{3}$ = $\\frac{2}{6}$ en $\\frac{1}{2}$ = $\\frac{3}{6}$",
          "Tel de tellers op: 2 + 3 = 5",
          "Antwoord: $\\frac{5}{6}$ liter"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{3}$ = $\\frac{2}{6}$ en $\\frac{1}{2}$ = $\\frac{3}{6}$. Samen: $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$ liter.",
          "1": "Je dacht waarschijnlijk dat je de tellers optelt (1+1=2) én de noemers optelt (3+2=5). Maar de noemers mag je niet optellen. Zoek het KGV: 6. Dan $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$.",
          "2": "Je hebt misschien de tellers vermenigvuldigd (1×1=1) en de noemers vermenigvuldigd (3×2=6). Dat is de regel voor vermenigvuldigen, niet voor optellen. Bij optellen maak je de noemers gelijk.",
          "3": "Je hebt alleen $\\frac{1}{3}$ omgezet naar $\\frac{2}{6}$ maar de tweede breuk vergeten op te tellen. $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$, niet $\\frac{2}{6}$."
        }
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-005",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "fill_in",
      "question": "Een schilder mengt $\\frac{2}{5}$ liter rode verf met $\\frac{1}{3}$ liter witte verf. Hoeveel verf heeft hij in totaal? Geef je antwoord als breuk (bv. 11/15).",
      "context": null,
      "options": [],
      "correctAnswer": "11/15",
      "data": {
        "acceptedAnswers": ["11/15", "$\\frac{11}{15}$"],
        "caseSensitive": false,
        "placeholder": "bv. 11/15",
        "unit": "liter"
      },
      "conceptId": "adding_fractions_context_paint",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "fractions": [
              {"numerator": 2, "denominator": 5, "label": "Rood: 2/5 liter"},
              {"numerator": 1, "denominator": 3, "label": "Wit: 1/3 liter"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ongelijknamige breuken optellen",
            "content": "Stap 1: Zoek het KGV van de noemers (5 en 3 → KGV = 15). Stap 2: Maak gelijknamig (2/5 = 6/15, 1/3 = 5/15). Stap 3: Tel de tellers op (6 + 5 = 11).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (5 en 3). Het KGV van 5 en 3 is 15. Maak gelijknamig: $\\frac{2}{5}$ = $\\frac{6}{15}$ (× 3) en $\\frac{1}{3}$ = $\\frac{5}{15}$ (× 5). Nu optellen: $\\frac{6}{15}$ + $\\frac{5}{15}$ = $\\frac{11}{15}$ liter verf.",
        "solutionSteps": [
          "Herken: de noemers zijn ongelijk (5 en 3)",
          "Zoek het KGV van 5 en 3: dat is 15",
          "Maak gelijknamig: $\\frac{2}{5}$ = $\\frac{6}{15}$ en $\\frac{1}{3}$ = $\\frac{5}{15}$",
          "Tel de tellers op: 6 + 5 = 11",
          "Antwoord: $\\frac{11}{15}$ liter"
        ]
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-CJ-001",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "comparison_judge",
      "question": "Welke som geeft de grootste uitkomst?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "½ + ⅓", "label": "een half plus een derde" },
            { "id": "b", "content": "¼ + ⅓", "label": "een kwart plus een derde" },
            { "id": "c", "content": "½ + ¼", "label": "een half plus een kwart" }
          ],
          "criterion": "de grootste uitkomst",
          "correctIndex": 0
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "fractions": [
              {"numerator": 1, "denominator": 2, "label": "½"},
              {"numerator": 1, "denominator": 3, "label": "⅓"},
              {"numerator": 1, "denominator": 4, "label": "¼"}
            ],
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "label": "½ + ⅓ = ³⁄₆ + ²⁄₆ = ⁵⁄₆ — dat is het grootst",
            "visualType": "bar"
          }
        }
      ],
      "conceptId": "breuk_optellen_ong_vergelijken",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Reken alle drie de sommen uit. ½ + ⅓ = ³⁄₆ + ²⁄₆ = ⁵⁄₆. ¼ + ⅓ = ³⁄₁₂ + ⁴⁄₁₂ = ⁷⁄₁₂. ½ + ¼ = ²⁄₄ + ¼ = ¾ = ⁹⁄₁₂. Maak vergelijkbaar: ⁵⁄₆ = ¹⁰⁄₁₂. Volgorde: ⁷⁄₁₂ < ⁹⁄₁₂ < ¹⁰⁄₁₂. Dus ½ + ⅓ is het grootst.",
        "solutionSteps": [
          "½ + ⅓ → noemer 6 → ³⁄₆ + ²⁄₆ = ⁵⁄₆",
          "¼ + ⅓ → noemer 12 → ³⁄₁₂ + ⁴⁄₁₂ = ⁷⁄₁₂",
          "½ + ¼ → noemer 4 → ²⁄₄ + ¼ = ¾",
          "Vergelijk met noemer 12: ⁵⁄₆ = ¹⁰⁄₁₂, ¾ = ⁹⁄₁₂",
          "Volgorde: ⁷⁄₁₂ < ⁹⁄₁₂ < ¹⁰⁄₁₂ → ½ + ⅓ is grootst"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}